export default defineNuxtRouteMiddleware(async () => {
  const { status, data, signOut } = useAuth();

  if (data.value?.email?.includes('guest:')) {
    return await signOut({ callbackUrl: '/login' });
  }

  if (status.value === 'authenticated' || status.value === 'loading') {
    return;
  }

  return await navigateTo('/login');
});
